export default __webpack_public_path__ + "static/media/juice-fruit-product-l-tablet.2d1d5984.png";